import { Map } from 'immutable';
import moment from 'moment-timezone';
import { myRemoveEntities, myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT, TIMETABLE_INIT, TIMETABLE_UPDATE } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LineActions from '../../actions/lines';
import * as LiveActions from '../../actions/live';
import * as MatchResultsAction from '../../actions/matchResults';
export default function matchesReducer(matches, action) {
    switch (action.type) {
        case PopularActions.CLEAR_POPULAR:
        case LineActions.CLEAR_LINE:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
        case MatchResultsAction.FETCH_MATCH_RESULTS:
        case MatchResultsAction.CLEAR_MATCH_RESULTS:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_FULL_LINE:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
        case MatchResultsAction.SUCCESS_FETCH_MATCH_RESULTS:
            return init(Map(), action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            matches = update(matches, action.data);
            if (action.data.events) {
                matches = expandMatches(matches, action.data.events.add);
            }
            return matches;
    }
    return matches;
}
function init(matches, data) {
    if (data.events !== undefined) {
        matches = addMatches(matches, data.events.add);
    }
    if (data.dates !== undefined) {
        matches = changeStartDates(matches, data.dates.add);
    }
    if (data.channels !== undefined) {
        matches = changeChannels(matches, data.channels.add);
    }
    if (data.blocked_events !== undefined) {
        matches = addBlockedMatches(matches, data.blocked_events.add);
    }
    if (data.remarks !== undefined) {
        matches = changeRemarks(matches, data.remarks.add);
    }
    if (data.periods !== undefined) {
        matches = changePeriods(matches, data.periods.add);
    }
    if (data.scores !== undefined) {
        matches = addMatchScores(matches, data.scores.add);
    }
    return matches;
}
function update(matches, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        matches = myRemoveEntitiesBySport(matches, 'sportId', data.sports.remove);
    }
    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        matches = myRemoveEntities(matches, 'leagueId', data.leagues.remove);
    }
    if (data.events !== undefined) {
        matches = myRemoveEntities(matches, 'id', data.events.remove);
        matches = addMatches(matches, data.events.add);
        matches = changeMatches(matches, data.events.change);
    }
    if (data.blocked_events !== undefined) {
        matches = removeBlockedMatches(matches, data.blocked_events.remove);
        matches = addBlockedMatches(matches, data.blocked_events.add);
    }
    if (data.dates !== undefined) {
        matches = changeStartDates(matches, data.dates.add);
    }
    if (data.channels !== undefined) {
        matches = removeChannels(matches, data.channels.remove);
        matches = changeChannels(matches, data.channels.add);
        matches = changeChannels(matches, data.channels.change);
    }
    if (data.periods !== undefined) {
        matches = changePeriods(matches, data.periods.add);
        matches = changePeriods(matches, data.periods.change);
        matches = removePeriods(matches, data.periods.remove);
    }
    if (data.remarks !== undefined) {
        matches = removeRemarks(matches, data.remarks.remove);
        matches = changeRemarks(matches, data.remarks.add);
        matches = changeRemarks(matches, data.remarks.change);
    }
    if (data.scores !== undefined) {
        matches = removeMatchScores(matches, data.scores.remove);
        matches = addMatchScores(matches, data.scores.add);
    }
    return matches;
}
function addMatches(matches, addMatches) {
    if (addMatches === undefined) {
        return matches;
    }
    return matches.withMutations(function (m) {
        for (var i = 0; i < addMatches.length; i++) {
            var match = new Map(addMatches[i]);
            match = match.set('scores', new Map());
            match = match.set('isBlocked', false);
            match = match.set('isClosed', true);
            match = match.set('isFullyLoaded', false);
            m.set(match.get('id'), match);
        }
    });
}
function changeMatches(matches, changeMatches) {
    if (changeMatches === undefined) {
        return matches;
    }
    for (var eventId in changeMatches) {
        if (!changeMatches.hasOwnProperty(eventId)) {
            continue;
        }
        (function (match) {
            var matchId = parseInt(match.id);
            var changedMatch = matches.get(matchId).merge(new Map(match));
            matches = matches.set(matchId, changedMatch);
        })(changeMatches[eventId]);
    }
    return matches;
}
function changeStartDates(matches, changeStartDates) {
    if (changeStartDates === undefined) {
        return matches;
    }
    for (var eventId in changeStartDates) {
        if (!changeStartDates.hasOwnProperty(eventId)) {
            continue;
        }
        (function (matchId, startDate) {
            startDate = moment.tz(startDate, 'Asia/Bishkek').clone().tz('UTC');
            matches = matches.setIn([parseInt(matchId), 'startDate'], startDate);
        })(eventId, changeStartDates[eventId]);
    }
    return matches;
}
function changeChannels(matches, changeChannels) {
    if (changeChannels === undefined) {
        return matches;
    }
    for (var eventId in changeChannels) {
        if (!changeChannels.hasOwnProperty(eventId)) {
            continue;
        }
        (function (matchId, channel) {
            matches = matches.setIn([parseInt(matchId), 'channel'], channel);
        })(eventId, changeChannels[eventId]);
    }
    return matches;
}
function removeChannels(matches, removeChannels) {
    if (removeChannels === undefined) {
        return matches;
    }
    for (var i = 0; i < removeChannels.length; i++) {
        (function (matchId) {
            matches = matches.deleteIn([matchId, 'channel']);
        })(removeChannels[i]);
    }
    return matches;
}
function changeRemarks(matches, changeRemarks) {
    if (changeRemarks === undefined) {
        return matches;
    }
    for (var eventId in changeRemarks) {
        if (!changeRemarks.hasOwnProperty(eventId)) {
            continue;
        }
        (function (matchId, remark) {
            matches = matches.setIn([parseInt(matchId), 'remark'], remark);
        })(eventId, changeRemarks[eventId]);
    }
    return matches;
}
function removeRemarks(matches, removeRemarks) {
    if (removeRemarks === undefined) {
        return matches;
    }
    for (var i = 0; i < removeRemarks.length; i++) {
        (function (matchId) {
            matches = matches.deleteIn([matchId, 'remark']);
        })(removeRemarks[i]);
    }
    return matches;
}
function changePeriods(matches, changePeriods) {
    if (changePeriods === undefined) {
        return matches;
    }
    for (var i = 0; i < changePeriods.length; i++) {
        (function (matchPeriod) {
            var matchId = matchPeriod.e;
            var periodId = matchPeriod.p;
            var minute = matchPeriod.m;
            var period = new Map({
                id: periodId,
                minute: minute
            });
            matches = matches.setIn([matchId, 'period'], period);
        })(changePeriods[i]);
    }
    return matches;
}
function removePeriods(matches, removePeriods) {
    if (removePeriods === undefined) {
        return matches;
    }
    for (var i = 0; i < removePeriods.length; i++) {
        (function (matchId) {
            matches = matches.deleteIn([matchId, 'period']);
        })(removePeriods[i]);
    }
    return matches;
}
function addBlockedMatches(matches, addBlockedMatches) {
    if (addBlockedMatches === undefined) {
        return matches;
    }
    for (var i = 0; i < addBlockedMatches.length; i++) {
        var matchId = addBlockedMatches[i];
        (function (matchId) {
            matches = matches.setIn([matchId, 'isBlocked'], true);
        })(matchId);
    }
    return matches;
}
function removeBlockedMatches(matches, removeBlockedMatches) {
    if (removeBlockedMatches === undefined) {
        return matches;
    }
    for (var i = 0; i < removeBlockedMatches.length; i++) {
        var matchId = removeBlockedMatches[i];
        (function (matchId) {
            matches = matches.setIn([matchId, 'isBlocked'], false);
        })(matchId);
    }
    return matches;
}
function addMatchScores(matches, addScores) {
    if (addScores === undefined) {
        return matches;
    }
    for (var i = 0; i < addScores.length; i++) {
        (function (score) {
            var matchId = score.matchId;
            var scoreType = score.type;
            matches = matches.setIn([matchId, 'scores', scoreType], score.id);
        })(addScores[i]);
    }
    return matches;
}
function removeMatchScores(matches, removeScores) {
    if (removeScores === undefined) {
        return matches;
    }
    for (var i = 0; i < removeScores.length; i++) {
        (function (score) {
            var matchId = score.matchId;
            var scores = matches.getIn([matchId, 'scores']);
            var key = scores.keyOf(score.id);
            matches = matches.deleteIn([matchId, 'scores', key]);
        })(removeScores[i]);
    }
    return matches;
}
function expandMatches(matches, loadedMatches) {
    if (loadedMatches === undefined) {
        return matches;
    }
    for (var i = 0; i < loadedMatches.length; i++) {
        matches = matches.updateIn([loadedMatches[i].id], function (m) {
            return m.set('isClosed', false);
        });
    }
    return matches;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/matchesReducer.js